import { render, staticRenderFns } from "./preservationForm.vue?vue&type=template&id=0393786b&scoped=true"
import script from "./preservationForm.vue?vue&type=script&lang=js"
export * from "./preservationForm.vue?vue&type=script&lang=js"
import style0 from "./preservationForm.vue?vue&type=style&index=0&id=0393786b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0393786b",
  null
  
)

export default component.exports